import { SET_BINGO_SCHEDULE } from './actions';

export const defaultState = {
    bingoSchedule: []
};

export const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_BINGO_SCHEDULE: {
            return {
                ...state,
                bingoSchedule: [...action.payload]
            };
        }
        default:
            return state;
    }
};
